import InternationalArchitectureAwardFrame from "./components/InternationalArchitectureAwardFrame";
import InternationalArchitectureAwardForm from "./components/InternationalArchitectureAwardForm";
import UserAccountRoutes from "../front_user_account/routes";

export default [
    {
        path: "/international-architecture-award",
        name: "international-architecture-award",
        redirect: "/international-architecture-award/account",
        meta: {
            auth: true,
            basePath: true,
            award: "internationalarchitecture",
            awardName: "International Architecture Award",
        },
        component: InternationalArchitectureAwardFrame,
        children: [
            {
                path: "",
                component: InternationalArchitectureAwardForm,
                name: "international-architecture-award-form",
            },
            ...UserAccountRoutes,
        ],
    },
];
